import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <p className="text-sm font-semibold text-link">404</p>
      <h1 className="mt-2 text-xl font-semibold text-ink">Page not found</h1>
      <p className="mt-1 text-sm text-ink-muted">That route doesn’t exist.</p>
      <Link to="/" className="mt-6">
        <Button>Back to Daily Brief</Button>
      </Link>
    </div>
  );
}
